module.exports = __webpack_public_path__ + "sombra.png?83d269cff6bfbea79bf28851d0afd375";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sombra.png
// module id = 67
// module chunks = 0